<template>
  <main class="main-wrapper flex-grow-1">
    <div class="d-flex align-items-center bg-white">
      <div
          class="
          t-headline13 t-color-headlineBlack
          pda-14
          t-center
          font-m
          flex-grow-1
        "
      >
        {{ $t("126") }}
      </div>
    </div>
    <div class="divider"></div>
    <div class="container container--narrow pdt-50">
      <label ref="answerEl"
             :class="isTextEmpty ? 'mdc-text-field--invalid' : ''"
             class="mdc-text-field mdc-text-field--textarea w-full mdc-text-field--outlined"
             data-mdc-auto-init="MDCTextField"
      >
          <textarea
              v-model="text"
              :class="isTextEmpty ? 'mdc-text-field--invalid' : ''"
              aria-labelledby="my-label-id"
              class="mdc-text-field__input t-body6 font-r pdl-16 pdr-16 pdb-16 t-line-h-26 l-spacing2 cursor-blue max-w-280 t-color-headlineBlack"
              cols="10"
              maxlength="1000"
              rows="11"
          ></textarea>
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch">
              <label id="label" class="mdc-floating-label text-area-label">
                {{ $t("127") }}</label>
              </span>
            <span class="mdc-notched-outline__trailing"></span>
          </span>
      </label>
      <div id="my-counter-number" class="mdc-text-field-helper-line">
        <div
            class="mdc-text-field-helper-text t-color-textfieldError t-helper font-r opacity-1 l-spacing36 t-line-h-20 mdc-text-field-helper-text--validation-msg">
            <span v-show="isTextEmpty && text === ''">
              {{ $t('3558') }}
            </span>
        </div>
        <div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"> 0 / 1000</div>
      </div>

      <div v-if="attachments.length">
        <div class="mgt-16"></div>
        <ul class="mdc-list pdt-0 pdb-0 ">
          <div v-for="(attachment, index) in attachments" :key="index"
               class="no-border-last bg-documentGray mgb-8 b-radius4">
            <li class="mdc-list-item align-items-center b-radius4" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span
                  aria-hidden="true"
                  class="mdc-list-item__graphic material-icons mgr-8 t-color-secondaryBtnText list-attach-close-small font16">attach_file</span>
              <span
                  class="mdc-list-item__text flex-grow-1 t-body3 t-color-signBlue t-line-h-24 l-spacing48 t-line-1 font-r">{{
                  attachment.originalName
                }}</span>
              <span aria-hidden="true" class="mdc-list-item__meta">
								<button
                    class="mdc-icon-button material-icons  t-color-secondaryBtnText list-attach-close-small h-42 font20"
                    @click="deleteFileIndex(index)" @keypress="deleteFileIndex(index)">close</button>
							</span>
            </li>
          </div>
        </ul>
      </div>
      <div class="mgt-50 d-flex justify-content-between">
        <button
            class="
            mdc-button mdc-button--raised
            bg-mainBtn
            t-color-mainBtnText
            b-radius4
          "
            tabindex="0" @click="isUpdate ? missionUpdate() : missionSubmit()" @keypress="isUpdate ? missionUpdate() : missionSubmit()"
        >
          <div class="mdc-button__ripple"></div>
          <span class="mdc-button__label t-body2 font-r">{{ $t("131") }} </span>
        </button>

        <input
            id="uploadAttachmentFile"
            ref="files"
            class="d-none"
            multiple
            type="file"
            @change="uploadAttachmentFile()"
            :accept="getSpecificAllowExt()"
        />
        <button
            class="
            mdc-button mdc-button--raised mdc-button--icon-leading
            bg-documentGray
            t-color-secondaryBtnText
            b-radius4
          "
            tabindex="0" @click="openFileUpload('uploadAttachmentFile')" @keypress="openFileUpload('uploadAttachmentFile')"
        >
          <div class="mdc-button__ripple"></div>
          <i aria-hidden="true" class="material-icons mdc-button__icon"
          >add</i
          >
          <span class="mdc-button__label t-body2 font-r">{{ $t("128") }}</span>
        </button>
      </div>

      <div class="pdt-24">
        <div class="t-body5 font-r t-color-bodyGrayA l-spacing39 mgb-4">{{ $t('3174') }}</div>
        <div class="d-flex">
          <div class="t-helper t-color-bodyGrayB t-line-h-20">{{ $t('3175') }}</div>
          <div class="pdl-8 pdr-8 t-helper t-color-bodyGrayB t-line-h-20">|</div>
          <div class="t-helper t-color-bodyGrayB t-line-h-20">{{ $t('3176') }}</div>
          <div class="pdl-8 pdr-8 t-helper t-color-bodyGrayB t-line-h-20">|</div>
          <div class="t-helper t-color-bodyGrayB t-line-h-20">{{ $t('3177') }}</div>
        </div>
      </div>
    </div>

    <!-- {{attachments}} -->
    <div class="mgt-50"></div>
  </main>
</template>

<script>
/**
 * 나의 학습 상세 - 미션 제출 / 수정 컴포넌트(my learning view - mission submit component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from "@/api/learnApi.js";
import {topAppBarMixin} from "@/mixins/topAppBar.js";
import {MDCTextField} from "@material/textfield";
import {fileMixin} from "@/mixins/file.js";
import {MDCRipple} from "@material/ripple";

export default {
  data() {
    return {
      answerEl: null,
      text: "",
      missionData: null,
      answerId: null,
      isTextEmpty: false
    };
  },
  mixins: [topAppBarMixin, fileMixin],

  mounted() {
    this.answerEl = new MDCTextField(this.$refs.answerEl);
    this.setMaterialUi();
    // 미션 수정일 때 제출한 답변 가져오기(get answers submitted for mission revisions)
    if (this.$route.name === "LearnViewMissionUpdate") {
      let params = {
        learnId: this.$route.params.learnId,
        assignmentId: this.$route.params.assignmentId,
      };

      learnApi.learnViewMissionView(params).then((response) => {
        this.missionData = response.data.data;
        this.attachments = this.missionData.answer.file;
        this.answerId = this.missionData.answer.id;
        this.text = this.missionData.answer.text;
        this.answerEl.value = this.text;
      });
    }
  },

  computed: {
    // 답안 입력 체크(validation answer)
    isSetAnswer() {
      return !!this.text || !!this.attachments.length;
    },

    // 수정 모드 체크(check update mode)
    isUpdate() {
      return !!this.answerId;
    },
  },

  methods: {
    // 미션 답안 제출(submit  mission answer)
    missionSubmit() {
      if (!this.isSetAnswer) {
        return this.isTextEmpty = true;
      }

      let params = {
        learnId: this.$route.params.learnId,
        assignmentId: this.$route.params.assignmentId,
        text: this.text,
        file: this.attachments,
      };

      learnApi
          .learnViewMissionSubmit(params)
          .then((response) => {
            this.$router.push({
              name: "LearnViewMissionViewSubmit",
            });
            this.setDialog();
          })
          .catch((err) => {
            // this.errorAlert();
          });
    },

    setDialog() {
      if (this.answerId) {
        this.$snackOpen({
          contents: this.$t('3480'),
          btnDisplayYN: false,
        }).then(() => {
        });
      } else if (!this.answerId) {
        this.$snackOpen({
          contents: this.$t("3467"),
          btnDisplayYN: false,
        }).then(() => {
        });
      }
    },

    // 미션 답안 수정(update mission answer)
    missionUpdate() {
      if (!this.isSetAnswer) {
        return this.isTextEmpty = true;
      }

      let params = {
        answerId: this.answerId,
        learnId: this.$route.params.learnId,
        assignmentId: this.$route.params.assignmentId,
        text: this.text,
        file: this.attachments,
      };

      learnApi
          .learnViewMissionUpdate(params)
          .then((response) => {
            this.$router.push({
              name: "LearnViewMissionViewSubmit",
            });
            this.setDialog();
          })
          .catch((err) => {
            // this.errorAlert();
          });
    },

    // 미션 제출 오류 메시지(error)
    errorAlert() {
      this.$alert({
        title: "TODO-과제 제출 오류",
        content: "TODO-과제를 제출하던 중 오류가 발생하였습니다.",
        accept: "TODO-확인", //확인
      }).then(() => {
        this.$router.push({
          name: "LearnViewMission",
        });
      });
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(
          document.querySelectorAll(".mdc-button"),
          function (el) {
            let button = new MDCRipple.attachTo(el);
            return button;
          }
      );
    },
  },
};
</script>
<style scoped>
.mdc-button--raised:not(:disabled), .mdc-button--unelevated:not(:disabled) {
  background-color: var(--SecondaryBtn);
}

.mdc-text-field--invalid .mdc-floating-label.mdc-floating-label--float-above {
  color: var(--Textfeilderror) !important;
}
</style>